export default "/images/stratus_logo.png?2dbf28811f0a7ecd6bbb67ba2f8aecdb";